import styled from 'styled-components';

export const Header = styled.div`
  padding: 20px 32px;
  background-color: var(--colorBlueGray1000);
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: var(--colorWhite);
  display: flex;
  justify-content: space-between;
  align-items: center;
  animation: fade-in 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
`;

export const Content = styled.div<{ maxWidth: string }>`
  max-width: ${({ maxWidth }) => maxWidth};
`;

export const Description = styled.div`
  font-size: 12px;
  color: var(--colorBlueGray200);
  margin-top: 4px;
  max-width: 90%;
`;
